module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w3-main main-container"
  }, [_c('page-header'), _vm._v(" "), _c('div', {
    staticClass: "w3-container about-container"
  }, [_c('h1', {
    staticClass: "w3-xxxlarge"
  }, [_c('b', [_vm._v(_vm._s(_vm.newsArticle.title[_vm.locale]))])]), _vm._v(" "), _c('hr', {
    staticClass: "w3-round"
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.newsArticle.text[_vm.locale])
    }
  }), _vm._v(" "), _c('gallery', {
    attrs: {
      "images": _vm.galleryImages.map(function (image) { return ("/static/images/news/gallery/" + (_vm.newsArticle._id) + "/" + image); }),
      "index": _vm.index,
      "options": {
        displayClass: 'blueimp-gallery-display-fix'
      }
    },
    on: {
      "close": function($event) {
        _vm.index = null
      }
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/hireink"
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Back to news')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "gallery-container"
  }, _vm._l((_vm.galleryImages), function(image, imageIndex) {
    return _c('div', {
      staticClass: "gallery-thumbnail",
      style: ({
        'background-image': ("url(/static/images/news/gallery/" + (_vm.newsArticle._id) + "/" + image + ")")
      }),
      on: {
        "click": function($event) {
          _vm.index = imageIndex
        }
      }
    })
  }), 0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/hireink"
    }
  }, [_c('button', {
    staticClass: "w3-button w3-block w3-padding-large w3-pink w3-margin-bottom"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('Back to news')) + "\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-119ad602","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsGallery.vue
// module id = 933
// module chunks = 0